<template>
	<div class="itm">
		<div
			:class="notify(item) ? 'itm__item itm__item_notify' : 'itm__item'"
			v-for="(item, index) in items.list"
			:key="index"
		>
			<!-- /////////////// -->
			<!-- Номер -->
			<div
				class="itm__item-instance"
				@click="
					onClickRedirect(
						'instance-detail',
						item.instance,
						item.channel
					)
				"
			>
				<div class="itm__item-instance-num">
					{{ item.instance }}
					<span class="itm__item-instance-channel">
						{{ formatChannel(item.sourceName, item.channel) }}
					</span>
				</div>
				<div
					v-if="hasExpirePaymentStamp(item.expirePaymentStamp)"
					:class="
						notify(item)
							? 'itm__item-instance-expire itm__item-instance-expire_notify'
							: 'itm__item-instance-expire'
					"
				>
					истекает {{ dataTimeFormat(item.expirePaymentStamp) }}
				</div>
			</div>

			<!-- /////////////// -->
			<!-- Статус -->
			<div class="itm__item-status">
				<UiStatusIndicator :value="item.status" />
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import UiStatusIndicator from "@/components/ui/UiStatusIndicator.vue";
import { IInstance } from "@/interfaces/IInstance";
import dayjs from "dayjs";
import "dayjs/locale/ru";
dayjs.locale("ru");

@Options({
	components: { UiStatusIndicator },
	props: {
		items: { type: Object, default: {} },
	},
})
export default class InstanceTableMob extends Vue {
	public items: Array<IInstance>;

	/**
	 * Переход на другую страницу
	 * @param routeName
	 * @param id
	 */
	/**
	 * Переходит в карточку инстанса и сохраняет канал в query.
	 */
	public onClickRedirect(routeName: string, id?: number, channel?: string) {
		// Канал передаем в URL, чтобы мобильная карточка открыла правильный источник.
		this.$router.push({
			name: routeName,
			params: { id: id },
			query: { channel: channel || "" },
		});
	}

	// Пользователю показываем человекочитаемое имя канала, технический код оставляем запасным вариантом.
	/**
	 * Возвращает человекочитаемое название канала для мобильной таблицы.
	 */
	public formatChannel(sourceName: string, channel: string) {
		if (sourceName) {
			return sourceName;
		}

		return (channel || "").toUpperCase();
	}

	/**
	 * Форматируем timestamp к виду - 15 августа 10:00
	 * @param timestamp
	 */
	public dataTimeFormat(timestamp: number) {
		if (!this.hasExpirePaymentStamp(timestamp)) {
			return "";
		}

		return dayjs(timestamp).format("DD MMMM HH:mm");
	}

	/**
	 * Проверяет, что срок действия инстанса заполнен и его можно показывать.
	 */
	public hasExpirePaymentStamp(timestamp: number | null | undefined) {
		return Boolean(timestamp);
	}

	/**
	 * Подсветка истёкших и истикающих каналов
	 * Если expired меньше за offset - тогда делаем выделение
	 * Если expired больше за offset - ничего не выделяем
	 * @param item
	 */
	public notify(item: {
		expirePaymentStamp: number;
		notificationOffset: number;
	}): boolean {
		const notificationOffset = item.notificationOffset;
		const expirePaymentStamp = item.expirePaymentStamp;

		if (!this.hasExpirePaymentStamp(expirePaymentStamp)) {
			return false;
		}

		const offset = dayjs().add(notificationOffset, "days").unix();
		return expirePaymentStamp < offset * 1000;
	}
}
</script>

<style scoped lang="scss">
.itm {
	padding: 8px;
	&__item {
		display: flex;
		background: rgb(252, 252, 252);
		padding: 16px;
		margin: 8px;
		justify-content: space-between;
		align-items: center;
		border-radius: 12px;
		box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);
	}

	&__item_notify {
		background: #f5f5f5;
	}

	&__item-instance {
		display: flex;
		flex-direction: column;
	}

	&__item-instance-num {
		font-size: 16px;
		color: rgb(49, 49, 50);
	}

	&__item-instance-channel {
		margin-left: 8px;
		color: rgb(119, 121, 124);
		font-size: 12px;
		font-weight: 600;
	}

	&__item-instance-expire {
		font-size: 14px;
		color: #77797c;
	}

	&__item-instance-expire_notify {
		color: #ff8585;
	}

	&__item-status {
	}
}
</style>
